import React, { FC } from "react";
import NumberFormat from "react-number-format";

import ErrorBar from "components/ErrorBar";

import styles from "./styles.module.scss";

type Props = {
  onChange(newValue: string): void;
  disabled?: boolean;
  currencySymbol?: string;
  error?: string;
  value: string;
  id?: string;
};

const CurrencyField: FC<Props> = ({
  onChange,
  disabled,
  currencySymbol = "$",
  error,
  value,
  id,
}) => {
  return (
    <div className={styles.container}>
      <NumberFormat
        id={id}
        className={styles.field}
        placeholder={`${currencySymbol}0.00`}
        value={value ?? "0.00"}
        thousandSeparator
        decimalScale={2}
        fixedDecimalScale
        disabled={disabled}
        prefix={currencySymbol}
        onValueChange={({ value: newValue }) => {
          if (!newValue) onChange("0.00");
          else onChange(newValue);
        }}
      />
      <ErrorBar id={id} error={error} />
    </div>
  );
};

CurrencyField.defaultProps = {
  disabled: false,
  currencySymbol: "$",
  error: undefined,
  id: undefined,
};

export default CurrencyField;
